import React from 'react';

interface BrandMarkProps {
  size?: number;
  className?: string;
  title?: string;
}

const BrandMark: React.FC<BrandMarkProps> = ({
  size = 64,
  className,
  title = 'Patinhas Sem Lar',
}) => (
  <img
    className={className}
    src={`${process.env.PUBLIC_URL}/paw.png`}
    width={size}
    height={Math.round(size * (458 / 544))}
    alt={title}
    decoding="async"
  />
);

export default BrandMark;
